import React from "react";
import PropTypes from "prop-types";

import Button from "components/button";
import { BASE_ASSETS_URL } from "constants/app";
import styles from "./noResultCard.scss";

const { noResult_card, noResult_content, noResult_heading, noResult_subHeading, noResult_image, noResult_button } = styles;

const NoResultCard = ({ heading, subHeading, showClearFilter, onClearFilter }) => (
  <div className={noResult_card}>
    <div className={noResult_content}>
      <div className={noResult_heading}>{heading}</div>
      <div className={noResult_subHeading}>{subHeading}</div>
      {showClearFilter && (
        <div className={noResult_button}>
          <Button onClick={onClearFilter} displayName={"Clear Filter"} />
        </div>
      )}
    </div>
    <div className={noResult_image}>
      <img src={`${BASE_ASSETS_URL}images/no-result.png`}></img>
    </div>
  </div>
);

NoResultCard.defaultProps = {
  heading: "No Result Found!",
  subHeading: "We couldn’t find what you are looking for.",
  showClearFilter: false,
  onClearFilter: () => {},
};

NoResultCard.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  showClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

export default NoResultCard;
